import React, { useState, useEffect } from "react";
import { client } from "../../services/api";
import classNames from "classnames";
import { requestOptions } from "../../constants/formOptions";
import ModalActivity from "../ModalActivity";
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

function StepActivitySelection({ formData, updateFormData }) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [projects, setProjects] = useState([]);
  useEffect(() => {
    client.getProjects()
      .then((resp) => setProjects(resp.data))
      .catch((err) => console.error(err.message));
  }, []);

  const handleChange = (selectedValue) => {
    updateFormData('project', selectedValue);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleDone = (newActivity) => {
    setProjects((prev) => [...prev, newActivity]);
    updateFormData('project', newActivity);
  };

  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    setInputValue(formData.project?.name || "");
  }, [formData.project]);
  
  return (
    <div>
      <h3>Request Information</h3>
      <p style={{ margin: '30px 0 3px' }}>Request name *</p>
      <input
        type="text"
        value={formData.name}
        onChange={(e) => updateFormData('name', e.target.value)}
      />
      <p style={{ margin: '30px 0 3px' }}>Request description</p>
      <textarea
        placeholder="less than 100 words"
        className="description"
        style={{ width: "100%" }}
        value={formData.description}
        onChange={(e) => updateFormData('description', e.target.value)}
      />
      <p style={{ margin: '30px 0 3px' }}>Select the related project</p>
      <Autocomplete
        style={{ flexGrow: 1 }}
        options={projects}
        getOptionLabel={(option) => option?.name || ""}
        value={formData.project || null}
        isOptionEqualToValue={(option, value) => option?._id === value?._id}
        onChange={(event, newValue) => handleChange(newValue)}
        inputValue={inputValue}
        onInputChange={(event, newInputValue) => setInputValue(newInputValue)}
        renderInput={(params) => <TextField {...params} label="Select a Project" variant="outlined" />}
        renderOption={(props, option) => (
          <li {...props} key={option._id}>
            {option.name}
          </li>
        )}
        slotProps={{
          listbox: {
            style: { maxHeight: "200px", overflow: "auto" },
          },
        }}
      />
      <button className="button-link" style={{ color: '#f0941d' }} onClick={() => setIsModalOpen(true)}>+Create a new project</button>
      <ModalActivity isOpen={isModalOpen} onClose={handleCloseModal} onDone={handleDone}></ModalActivity>

      <h3>Activities Scope</h3>
      <div className="request-scope-wrapper">
        {requestOptions.map(({ title, image, disabled }, index) => {
          const isEnabled =
            title === "Assessment and Monitoring" ||
            (title === "Land Use and Land Cover" && formData.requestType?.includes("Assessment and Monitoring"));
          return (
          <div
            key={index}
            onClick={() => {
              const updatedRequestTypes = formData.requestType?.includes(title)
                ? formData.requestType.filter((item) => item !== title)
                : [...(formData.requestType || []), title];
          
              updateFormData("requestType", updatedRequestTypes);
            }}
            className={classNames("request-scope-container", { active: formData.requestType?.includes(title), disabled: !isEnabled })}
          >
            <img
              src={image}
              alt={title}
              style={{ width: "100%", height: "100px", objectFit: "cover" }}
            />
            <div className="request-scope-text">{title}</div>
          </div>
        )})}
      </div>
    </div>
  );
}

export default StepActivitySelection;
